

































































































	import AbpBase from "@/lib/abpbase";
    import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
	import {UnorderedBed} from "@/api/bedScheduling"

	@Component({})
	export default class Country extends AbpBase {
		@Prop({type: Boolean, default: false}) value: boolean;
		@Prop({type: Object, default: {}}) data: any;

        async save(){
            console.log(this.data.list2)
            let data = this.data.list2.filter((item:any)=>{
                return item.$drops
            })
            console.log(data)   
            let data2:any = []
            data.forEach((item:any)=>{
                data2.push({
                    id:item.row.id,
                    badId:item.row.badId,
                    shiftId:item.row.shiftId,
                    patientId:item.row.patientId,
                    dialysisModelCode:item.row.dialysisModelCode,
                    machineType:item.row.machineType,
                    colorEnum:item.row.colorEnum,
                    flagEnum:item.row.flagEnum,
                    dialysisDate:item.row.dialysisDate,
                    weekDay:item.row.weekDay,
                    remark:item.row.remark,
                    weekFlag:this.data.weekPosition==1?'本周':'下周',
                })
            })
            
            let res= await UnorderedBed(data2)
            if(res.status==1){
                this.$emit('input', false);
                this.$emit('on-success')
            }
        }
		visibleChange(value: boolean) {
			if (!value) {
				this.$emit('on-cancel');
				this.$emit('input', value);
			}
		}
		cancel(){
            this.$emit('on-cancel');
            this.$emit('input', false);
        }
        type = null
        dragstart(event: any, type:any ,item: any) {
            this.type = type
            event.dataTransfer.setData('item', JSON.stringify(item))
        }
        // 拖动事件结束后，清理数据
		dragend(event: any,type:any) {
			event.dataTransfer.clearData()
        }
        dragover(event: any,type:any){
            event.preventDefault()
        }
        drop(event:any,type:any,val:any){
            let index = JSON.parse(event.dataTransfer.getData('item'))
            let row 
            if(this.type==1){
                row = Object.assign({},this.data.list1[index].row)
                if(type==2){
                    this.data.list1[index].$drops = false
                    this.data.list2[val].$drops = true
                    //换掉床号班次日期
                    row.badId = this.data.list2[val].bed.id
                    row.shiftId = this.data.list2[val].shift.id
                    row.dialysisDate = this.data.list2[val].time.split('/')[0]
                    row.weekDay = this.data.list2[val].time.split('/')[1]
                    this.data.list2[val].row = row
                }
            }else{
                row = Object.assign({},this.data.list2[index].row)
                if(type==1){
                    console.log(index)
                    if(this.data.list2[index].row.patientName == this.data.list1[val].row.patientName){
                        this.data.list2[index].$drops = false
                        this.data.list2[index].row = null

                        this.data.list1[val].$drops = true
                    }
                    //换掉床号班次日期
                    row.badId = this.data.list1[val].bed.id
                    row.shiftId = this.data.list1[val].shift.id
                    row.dialysisDate = this.data.list1[val].time.split('/')[0]
                    row.weekDay = this.data.list1[val].time.split('/')[1]
                    this.data.list1[val].row = row
                }else if(!this.data.list2[val].$drops){
                    this.data.list2[val].$drops = true
                    //换掉床号班次日期
                    row.badId = this.data.list2[val].bed.id
                    row.shiftId = this.data.list2[val].shift.id
                    row.dialysisDate = this.data.list2[val].time.split('/')[0]
                    row.weekDay = this.data.list2[val].time.split('/')[1]
                    this.data.list2[val].row = row
                    this.data.list2[index].$drops = false
                    this.data.list2[index].row = null
                }
            }
            console.log(this.data)
        }
	}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/bedScheduling/bed/parts/changebed.vue